import React, { FunctionComponent } from 'react';

interface JustGivingLogoProps {
  width?: string;
  height?: string;
  className?: string;
}

export const JustGivingLogo: FunctionComponent<JustGivingLogoProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width ?? '112'}
      height={height ?? '20'}
      viewBox="0 0 529 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M300.581 17.1426H282.213V72.5483H300.581V17.1426Z"
        fill="#7A04DD"
      />
      <path
        d="M276.349 29.0191H250.382L235.182 44.1225H256.042C253.327 50.194 247.196 54.4308 240.086 54.4308C230.448 54.4308 222.626 46.6397 222.626 37.0406C222.626 27.4325 230.448 19.6238 240.086 19.6238C243.583 19.6238 246.84 20.6431 249.563 22.4069L263.632 8.4026C257.216 3.15541 249.002 0 240.041 0C219.52 0 202.879 16.5747 202.879 37.0406C202.879 57.4798 219.52 74.0546 240.041 74.0546C260.589 74.0546 277.239 57.4798 277.239 37.0406C277.239 34.284 276.927 31.5895 276.349 29.0191Z"
        fill="#7A04DD"
      />
      <path
        d="M300.581 1.27539H282.213V12.4523H300.581V1.27539Z"
        fill="#7A04DD"
      />
      <path
        d="M341.988 72.9376H326.121L325.97 72.5476L304.221 17.1152H323.825L334.166 47.9159L344.586 17.1152H363.897L341.988 72.9376Z"
        fill="#7A04DD"
      />
      <path
        d="M385.664 17.1426H367.27V72.5483H385.664V17.1426Z"
        fill="#7A04DD"
      />
      <path
        d="M385.664 1.27539H367.27V12.4523H385.664V1.27539Z"
        fill="#7A04DD"
      />
      <path
        d="M442.716 72.5478H424.357V41.818C424.357 36.0479 421.963 33.1052 417.229 33.1052C411.106 33.1052 409.843 37.8561 409.843 41.818V72.5389H391.448V17.1421H404.183L409.229 22.1322C413.215 18.1082 417.834 16.1582 423.245 16.1582C435.249 16.1582 442.707 24.2151 442.707 37.1913L442.716 72.5478Z"
        fill="#7A04DD"
      />
      <path
        d="M24.6324 73.5041C15.0393 73.5041 7.07469 69.8878 1.02338 62.7172L0 61.5117L12.4586 49.1117L13.1705 49.8828C17.1127 54.1994 20.4143 56.0518 24.2408 56.0518C29.2065 56.0518 31.5469 53.0648 31.5469 46.6565V1.27539H50.5195V47.3479C50.5195 63.9581 41.0777 73.5041 24.6324 73.5041Z"
        fill="#7A04DD"
      />
      <path
        d="M492.674 17.143L488.002 21.8317C483.58 17.9495 478.623 16.168 472.465 16.168C459.997 16.168 447.361 25.1556 447.361 42.3153V42.5192C447.361 59.6966 459.988 68.6842 472.465 68.6842C478.374 68.6842 483.01 67.0356 487.282 63.375C486.49 69.9162 482.521 74.2771 474.592 74.2771C469.813 74.2771 465.693 73.4173 461.412 71.5117L449.39 83.4863L451.054 84.346C458.048 88.0332 466.316 90.0009 474.983 90.0009C496.163 90.0009 506.014 79.2672 506.014 59.2357V17.143H492.674ZM488.554 42.528C488.554 48.9186 483.58 53.5542 476.718 53.5542C469.813 53.5542 465.007 49.025 465.007 42.528V42.3153C465.007 35.9247 469.937 31.298 476.718 31.298C483.58 31.298 488.554 35.9247 488.554 42.3153V42.528Z"
        fill="#7A04DD"
      />
      <path
        d="M76.1486 73.5056C64.1439 73.5056 56.6954 65.4487 56.6954 52.4636V17.1426H75.0629V47.8192C75.0629 53.607 77.4568 56.5408 82.1554 56.5408C88.2957 56.5408 89.5594 51.79 89.5594 47.8192V17.1426H107.98V72.5483H95.2191L90.1734 67.5404C86.1778 71.5556 81.5859 73.5056 76.1486 73.5056Z"
        fill="#7A04DD"
      />
      <path
        d="M183.978 73.4154C172.578 73.4154 167.025 67.7428 167.025 56.0341V33.317H160.822V17.1322H167.025V1.27539H185.401V17.1322H197.611V33.3081H185.401V53.6232C185.401 56.0873 186.078 56.823 188.347 56.823C190.616 56.823 192.788 56.2911 194.736 55.2009L197.433 53.7473V69.6307L196.552 70.1448C192.805 72.3784 188.827 73.4154 183.978 73.4154Z"
        fill="#7A04DD"
      />
      <path
        d="M141.084 38.4411L139.376 37.8827C135.087 36.4379 131.02 35.0729 131.02 33.2648V33.0609C131.02 31.2616 133.271 30.6235 135.38 30.6235C138.326 30.6235 142.304 31.8555 146.575 34.0005L157.174 23.444L156.328 22.8856C150.366 18.8882 142.642 16.5039 135.674 16.5039C123.206 16.5039 114.841 23.7986 114.841 34.6475V34.8514C114.841 45.656 123.375 49.6091 131.705 52.0377C132.399 52.2593 133.084 52.4543 133.743 52.6581C138.121 53.9433 141.912 55.0601 141.912 57.0278V57.2317C141.912 59.4742 139.118 59.9617 136.76 59.9617C132.283 59.9617 126.997 58.0737 121.987 54.7588L111.878 64.8455L111.736 65.0493L112.634 65.7407C119.469 71.1208 127.905 74.0812 136.377 74.0812C149.966 74.0812 158.09 67.2031 158.09 55.6363V55.4324C158.09 44.096 147.011 40.4265 141.084 38.4411Z"
        fill="#7A04DD"
      />
      <path
        d="M509.823 19.6509H512.457V25.9706H515.411V19.6509H518.019V17.1426H509.823V19.6509Z"
        fill="#7A04DD"
      />
      <path
        d="M525.885 17.1426L523.972 20.2271L522.05 17.1426H518.98V25.9706H521.89V21.5743L523.225 23.6307H524.666L526.019 21.5743V25.9706H529V17.1426H525.885Z"
        fill="#7A04DD"
      />
    </svg>
  );
};
